/* unplugin-vue-components disabled */import { render } from "./audio.vue?vue&type=template&id=7e5dfe94&scoped=true"
import script from "./audio.vue?vue&type=script&lang=js"
export * from "./audio.vue?vue&type=script&lang=js"

import "./audio.vue?vue&type=style&index=0&id=7e5dfe94&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e5dfe94"],['__file',"src/components/ai-chat/ai-file/audio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e5dfe94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e5dfe94', __exports__)) {
    api.reload('7e5dfe94', __exports__)
  }
  
  module.hot.accept("./audio.vue?vue&type=template&id=7e5dfe94&scoped=true", () => {
    api.rerender('7e5dfe94', render)
  })

}


export default __exports__